import React, { useRef, useState } from 'react';
import { Box, Typography, TextareaAutosize, useTheme, useMediaQuery } from '@mui/material';

const CustomTextarea = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
  minRows = 2,
  maxRows = 4,
  placeholder = "",
  ...props
}) => {
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Helper function to manage focus
  const focusTextarea = () => {
    if (textareaRef.current && !textareaRef.current.disabled) {
      textareaRef.current.focus();
    }
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    e.target.style.borderColor = '#2259c9';
    e.target.style.borderWidth = '2px';
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    e.target.style.borderColor = '#e0e0e0';
    e.target.style.borderWidth = '1px';
  };

  return (
    <Box 
      sx={{ 
        position: 'relative',
        cursor: 'text',
        width: '100%',
        mb: -6
      }}
      onClick={focusTextarea}
    >
      <Typography
        variant="body2"
        sx={{
          position: 'absolute',
          top: value || isFocused ? '-8px' : '16px',
          left: '12px',
          backgroundColor: 'white',
          padding: '0 8px',
          color: (value || isFocused) ? '#2259c9' : '#6c757d',
          fontWeight: (value || isFocused) ? 500 : 400,
          fontSize: (value || isFocused) ? { xs: '11px', sm: '12px' } : { xs: '14px', sm: '16px' },
          zIndex: 10,
          transition: 'all 0.2s ease-in-out',
          pointerEvents: 'none',
          userSelect: 'none'
        }}
        onClick={focusTextarea}
      >
        {label} {required && '*'}
      </Typography>
      <TextareaAutosize
        ref={textareaRef}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        minRows={minRows}
        maxRows={maxRows}
        style={{
          width: '100%',
          padding: (value || isFocused) ? 
            isMobile ? '20px 10px 6px 10px' : '24px 12px 8px 12px' : 
            isMobile ? '14px 10px' : '16px 12px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          fontSize: isMobile ? '14px' : '16px',
          fontFamily: 'inherit',
          resize: 'vertical',
          backgroundColor: 'white',
          outline: 'none',
          transition: 'border-color 0.2s ease-in-out',
          cursor: 'text',
          minHeight: isMobile ? '70px' : '80px',
          position: 'relative',
          zIndex: 1,
          boxSizing: 'border-box',
          lineHeight: isMobile ? '1.4' : '1.5'
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...props}
      />
    </Box>
  );
};

export default CustomTextarea; 